<!-- GENERATED FILE -->
<script>
  import { getContext } from "svelte";

  const ctx = getContext("iconCtx") || {};

  export let weight = ctx.weight ?? "regular";
  export let color = ctx.color ?? "currentColor";
  export let size = ctx.size ?? "1em";
  export let mirrored = ctx.mirrored || false;
</script>

<svg 
  xmlns="http://www.w3.org/2000/svg" 
  width={size}
  height={size}
  fill={color}
  transform={mirrored ? "scale(-1, 1)" : undefined} 
  viewBox="0 0 256 256"
  {...$$restProps}>
  <slot/>
  <rect width="256" height="256" fill="none" />
  {#if weight === "bold"}
    <path d="M208,172a11.96187,11.96187,0,0,1-8.48535-3.51465L128,96.9707,56.48535,168.48535a12.0001,12.0001,0,0,1-16.9707-16.9707l80-80a11.99975,11.99975,0,0,1,16.9707,0l80,80A12,12,0,0,1,208,172Z"/>
  {:else if weight === "duotone"}
    <g opacity="0.2"><polygon points="48 160 128 80 208 160 48 160"/></g><path d="M208,168H48a7.99981,7.99981,0,0,1-5.65674-13.65674l80-80a8,8,0,0,1,11.31348,0l80,80A7.99981,7.99981,0,0,1,208,168ZM67.314,152H188.686L128,91.314Z"/>
  {:else if weight === "fill"}
    <path d="M215.39111,163.06152A8.00015,8.00015,0,0,1,208,168H48a7.99981,7.99981,0,0,1-5.65674-13.65674l80-80a8,8,0,0,1,11.31348,0l80,80A7.99982,7.99982,0,0,1,215.39111,163.06152Z"/>
  {:else if weight === "light"}
    <path d="M208,166a5.98159,5.98159,0,0,1-4.24268-1.75732L128,88.48535,52.24268,164.24268a6.00006,6.00006,0,0,1-8.48536-8.48536l80-80a6.00078,6.00078,0,0,1,8.48536,0l80,80A6,6,0,0,1,208,166Z"/>
  {:else if weight === "thin"}
    <path d="M208,164a3.98881,3.98881,0,0,1-2.82861-1.17139L128,85.65674,50.82861,162.82861a4.00026,4.00026,0,0,1-5.65722-5.65722l80-80a4.00147,4.00147,0,0,1,5.65722,0l80,80A4,4,0,0,1,208,164Z"/>
  {:else if weight === "regular"}
    <path d="M208,168a7.97507,7.97507,0,0,1-5.65674-2.34326L128,91.314,53.65674,165.65674a7.99984,7.99984,0,0,1-11.31348-11.31348l80-80a8,8,0,0,1,11.31348,0l80,80A8,8,0,0,1,208,168Z"/>
  {:else}
    {(console.error('Unsupported icon weight. Choose from "thin", "light", "regular", "bold", "fill", or "duotone".'), "")}
  {/if}
</svg>